var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0234375,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2205_43234)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 27.0234C21.1793 27.0234 27 21.2022 27 14.0222C27 6.84213 21.1793 1.02344 14 1.02344C6.82067 1.02344 1 6.84467 1 14.0247C1 21.2047 6.82067 27.0234 14 27.0234Z",
    fill: "#C30037"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1641 18.5989H14.4722V8.42444H13.4741V19.6047H14.4722V19.597H17.1641V18.5989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8841 14.4387H17.1797V13.4405H24.8644C24.8746 13.6335 24.8796 13.8266 24.8796 14.0221C24.8796 20.0339 20.0088 24.9052 13.9976 24.9052C7.9865 24.9052 3.11816 20.0339 3.11816 14.0247C3.11816 8.01549 7.98904 3.1416 14.0002 3.1416C14.1576 3.1416 14.3176 3.14414 14.4751 3.15176L14.4725 4.14229C14.3151 4.13467 14.1576 4.13213 14.0002 4.13213C8.53758 4.13213 4.10859 8.56155 4.10859 14.0247C4.10859 19.4878 8.53758 23.9172 14.0002 23.9172C19.3155 23.9172 23.6505 19.7265 23.8816 14.4691L23.8841 14.4387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93946 11.4366C10.7851 11.4366 11.4683 10.7508 11.4683 9.90763C11.4683 9.06187 10.7826 8.37866 9.93946 8.37866C9.09379 8.37866 8.41064 9.06441 8.41064 9.90763C8.41064 10.7508 9.09633 11.4366 9.93946 11.4366Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2205_43234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(1 1.02344)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLu);
export default __webpack_public_path__ + "static/media/lu.d1e7d319d9eab06d1a16d9846865382c.svg";
export { ForwardRef as ReactComponent };